<template>
  <v-alert border="top" colored-border type="error" elevation="2">
    <h3>ご迷惑をおかけいたします</h3>
    <pre class="my-3 text-body-2">{{ explanationMessage }}</pre>
    <v-divider class="my-5"></v-divider>
    <div class="pa-3 my-3 rounded-sm grey lighten-2">
      <div>リクエストID：{{ requestId }}</div>
      <div>エラーメッセージ：{{ errorCode }} - {{ errorMessage }}</div>
    </div>
    <v-btn @click="gotoTopClick">
      トップに戻る
    </v-btn>
  </v-alert>
</template>

<script>
const explanation = `サーバーにてシステムエラーが発生したため、処理を完了することができませんでした。
誠に申し訳ございませんが、トップ画面に戻ってから処理をやり直していただきますようお願いいたします。
繰り返しエラーが発生してしまう場合は、臨時のサーバーメンテナンス中あるいはトラブルによってシステムダウン中の可能性がございます。
その場合にはブラウザを閉じ、時間をおいてからお試しいただきますようお願いいたします。`;

export default {
  name: 'SystemError',
  props: {
    errorCode: String,
    requestId: String,
    errorMessage: String,
  },
  computed: {
    explanationMessage: () => explanation,
  },
  methods: {
    gotoTopClick() {
      this.$emit('goto-top-click');
    },
  },
};
</script>

<style scoped>
pre {
  white-space: pre-wrap;
}
</style>
